import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { startExam } from "../../../redux/slice/examSlice";
import ConfirmBox from "../common/ConfirmBox";

const TopicItem = ({ topic }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [showBox, setShowBox] = useState(false);

  const handleStart = () => {
    setShowBox(true);
    // navigate("/client/topics");
  };

  const handleBackDrop = () => {
    setShowBox(false);
  };

  const handleCancel = () => {
    setShowBox(false);
  };

  const handleConfirm = () => {
    setShowBox(false);
    const data = { topicName: topic.topicName };
    dispatch(startExam(data));
    navigate("/client/take-exam");
  };

  return (
    <div className="md:col-span-3 col-span-4 w-full">
      <button
        onClick={handleStart}
        className="flex h-[150px] w-full items-center rounded-[10px] border border-secondary  hover:scale-105 text-secondary bg-secondary/10 hover:ease-in duration-150"
      >
        <span className="w-full text-center font-medium tracking-wide text-[36px] px-0">
          {topic.topicName}
        </span>
      </button>
      {showBox && (
        <ConfirmBox
          onBackDrop={handleBackDrop}
          onConfirm={handleConfirm}
          onCancel={handleCancel}
          message="start"
        />
      )}
    </div>
  );
};

export default TopicItem;
